<app-header *ngIf="!maintenanceMode"></app-header>

<div class="container-fluid col-md-12">
  <div *ngIf="menu && !userLocation.path().includes('scheduler/search'); else elseBlock">
    <div class="row">
      <div [ngClass]="userLocation.path().includes('/scheduler') ? 'col-lg-3' : 'col-lg-2'">
        <app-side-navigation [menu]="menu"></app-side-navigation>
      </div>
      <div [ngClass]="userLocation.path().includes('/scheduler') ? 'col-lg-9' : 'col-lg-10'">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <ng-template #elseBlock>
    <div class="row">
      <div class="col-lg-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </ng-template>
</div>
<ngx-ui-loader></ngx-ui-loader>
